import { mockUsers } from '../mockData';
import { DEFAULT_BRANDING } from '../../theme/defaultBranding';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const MOCK_LOAN = {
  loanNumber: 'UFF-100245',
  loanAmount: 425000,
  loanType: 'Conventional',
  loanPurpose: 'Purchase',
  currentStage: 'Processing',
  milestones: [
    { key: 'application', label: 'Application', completed: true, current: false },
    { key: 'processing', label: 'Processing', completed: false, current: true },
    { key: 'underwriting', label: 'Underwriting', completed: false, current: false },
    { key: 'conditions', label: 'Conditions', completed: false, current: false },
    { key: 'clear_to_close', label: 'Clear to Close', completed: false, current: false },
    { key: 'funded', label: 'Funded', completed: false, current: false },
  ],
  noteRate: 6.5,
  productName: 'Conforming 30-Year Fixed',
  monthlyPayment: 2685.42,
  loName: 'Alex Morgan',
  loPhone: '8165550100',
  loEmail: 'alex.morgan@example.com',
  propertyCity: 'Kansas City',
  propertyState: 'MO',
  propertyZip: '64111',
  borrowers: [{ firstName: 'Jordan', lastName: 'Lee' }],
  keyDates: {
    applicationDate: '2026-06-01',
    estimatedClosing: '2026-08-15',
  },
};

const MOCK_CONDITIONS = {
  actionNeeded: [
    {
      id: 'cond-1',
      name: 'Most recent pay stubs',
      status: 'Uploaded',
      description: 'Upload your last 30 days of pay stubs.',
    },
  ],
  underReview: [
    {
      id: 'cond-2',
      name: 'Bank statements',
      status: 'Reviewed',
      description: 'Two months of checking account statements.',
    },
  ],
  approved: [
    {
      id: 'cond-3',
      name: 'Photo ID',
      status: 'Accepted',
      description: 'Government-issued photo identification.',
    },
  ],
};

/**
 * Minimal mock base query for offline borrower-portal development.
 * Covers auth user-info and a few common auth endpoints used by pages.
 */
export const mockBaseQuery = async (args) => {
  await delay(300);

  const url = typeof args === 'string' ? args : args.url;
  const method = (args.method || 'GET').toUpperCase();
  const body = typeof args === 'string' ? undefined : args.body;

  if (url === '/auth/user-info' && method === 'GET') {
    const user = mockUsers[0];
    return {
      data: {
        sub: user.id,
        given_name: user.firstName,
        family_name: user.lastName,
        email: user.email,
        role: user.role,
      },
    };
  }

  if (url === '/auth/forgot-password' && method === 'POST') {
    return { data: { success: true } };
  }

  if (url === '/auth/forgot-password/verify' && method === 'POST') {
    return { data: { success: true } };
  }

  if (typeof url === 'string' && url.includes('/confirm/status') && method === 'GET') {
    return { data: { isValid: true, email: mockUsers[0].email } };
  }

  if (typeof url === 'string' && url.includes('/confirm') && method === 'POST') {
    return { data: { success: true } };
  }

  if (url === '/branding' && method === 'GET') {
    return {
      data: {
        ...DEFAULT_BRANDING,
        id: '00000000-0000-0000-0000-000000000001',
        hostName: 'localhost',
        leadSource: 'bcc.uff.pro',
        isActive: true,
      },
    };
  }

  if (url === '/auth/token' && method === 'POST') {
    const params = new URLSearchParams(typeof body === 'string' ? body : '');
    if (params.get('grant_type') === 'urn:lk:borrower-verification') {
      return {
        data: {
          access_token: 'mock-borrower-token',
          token_type: 'Bearer',
          expires_in: 3600,
        },
      };
    }
  }

  if (url === '/borrower/applications' && method === 'POST') {
    return {
      data: {
        applicationNumber: `APP-${Date.now().toString().slice(-8)}`,
        id: crypto.randomUUID?.() || 'mock-app-id',
      },
    };
  }

  if (url === '/borrower/loan' && method === 'GET') {
    return { data: MOCK_LOAN };
  }

  if (url === '/borrower/conditions' && method === 'GET') {
    return { data: MOCK_CONDITIONS };
  }

  if (typeof url === 'string' && url.startsWith('/borrower/conditions/') && method === 'POST') {
    return { data: { success: true } };
  }

  console.warn(`[mockApiHandler] Unhandled mock request: ${method} ${url}`);
  return { error: { status: 404, data: `No mock handler for ${method} ${url}` } };
};
